"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("elevate-ui/Button"));

var _Delete = _interopRequireDefault(require("elevate-ui-icons/Delete"));

var _Cancel = _interopRequireDefault(require("elevate-ui-icons/Cancel"));

var _Modal = _interopRequireDefault(require("./Modal"));

var _Typography = _interopRequireDefault(require("elevate-ui/Typography"));

var _withStyles = _interopRequireDefault(require("elevate-ui/withStyles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Delete = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Delete, _Component);

  var _super = _createSuper(Delete);

  function Delete(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Delete);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "toggleConfirmation", function () {
      return _this.setState(function (state) {
        return {
          showConfirmation: !state.showConfirmation
        };
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleDelete", function () {
      _this.props.deleteContent(_this.props.id);

      return _this.toggleConfirmation();
    });
    _this.state = {
      showConfirmation: false
    };
    return _this;
  }

  (0, _createClass2["default"])(Delete, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className;
      var showConfirmation = this.state.showConfirmation;
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: this.toggleConfirmation,
        className: (0, _classnames["default"])(classes.trash, className)
      }, /*#__PURE__*/_react["default"].createElement(_Delete["default"], {
        size: 16
      })), /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
        isOpen: showConfirmation
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        type: "heading6",
        className: classes.confirmText,
        gutterBottom: true
      }, "Are you sure you want to delete this block?"), /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.buttonRow
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: this.toggleConfirmation,
        icon: /*#__PURE__*/_react["default"].createElement(_Cancel["default"], null),
        type: "button",
        color: "#CCCCCC",
        isOutlined: true,
        className: classes.buttonCancel
      }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        onClick: function onClick() {
          return _this2.handleDelete();
        },
        icon: /*#__PURE__*/_react["default"].createElement(_Delete["default"], null),
        type: "button",
        color: "primary"
      }, "Delete"))));
    }
  }]);
  return Delete;
}(_react.Component);

var styles = function styles(theme) {
  return {
    trash: {
      display: "flex"
    },
    confirmText: {
      textAlign: "center"
    },
    buttonRow: {
      display: "flex",
      flexFlow: "row nowrap",
      justifyContent: "flex-end",
      alignItems: "center",
      marginTop: 20,
      paddingRight: 20
    },
    buttonCancel: {
      marginRight: 8
    }
  };
};

var _default = (0, _withStyles["default"])(styles, {
  name: "Delete"
})(Delete);

exports["default"] = _default;